import React from 'react';

import AppBarProvider from 'components/AppBar/AppBarProvider';

import CssBaseline from '@material-ui/core/CssBaseline';

import { SnackbarProvider } from 'notistack';
import AuthProvider from 'components/Auth/AuthProvider';
import SharedDialogProvider from 'components/SharedDialog/SharedDialogProvider';
import SharedDialogRenderer from 'components/SharedDialog/SharedDialogRenderer';
import StoreProvider from 'components/Store/StoreProvider';
import ThemeProvider from 'components/Theme/ThemeProvider';
import EnvironmentProvider from 'components/Environment/EnvironmentProvider';

import dialogs from './dialogs';
import AppSwitchAndRoutes from './AppSwitchAndRoutes';
import Footer from 'components/Footer';


export default function App() {
  return (
    <EnvironmentProvider>
      <SnackbarProvider maxSnack={1} anchorOrigin={{horizontal:"center", vertical:"bottom"}}>
        <ThemeProvider>
          <AuthProvider>
            <StoreProvider>
              <SharedDialogProvider dialogs={dialogs}>
                <CssBaseline />
                  <SharedDialogRenderer>
                    <AppBarProvider>
                      <AppSwitchAndRoutes />
                      <Footer />
                    </AppBarProvider>
                  </SharedDialogRenderer>
              </SharedDialogProvider>
            </StoreProvider>
          </AuthProvider>
        </ThemeProvider>
      </SnackbarProvider>
    </EnvironmentProvider>
  );
}